import { Injectable } from '@angular/core';
import { throwError, Observable, BehaviorSubject } from 'rxjs';
import { UserInfo, UserInfoAdapter } from '../Models/user-info';
import { ApiRestService } from './api-rest.service';
import { map, catchError} from 'rxjs/operators';
import { __values } from 'tslib';
//import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';
//import { UserProfile } from '../Models/user-profile';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  userInfo;
  //adminUser : boolean = false;
  userType : string;
  userActive : boolean = false;
  userName : string;
  userPNumber : string;
  //private _userInfoState = new BehaviorSubject<UserInfo>(null);
  //readonly currentUserInfo$ = this._userInfoState.asObservable();

  private apiCall = '/getuserlist/';
  constructor(private apiRestService: ApiRestService
              , private adapter : UserInfoAdapter) { 
  }

  getCurrentUserInfo() {
    this.userInfo = this.getUserInfoStorage();
    // if (this.userInfo !== undefined && this.userInfo !== null || Object.keys(this.userInfo).length === 0) {
    if (this.userInfo !== undefined && this.userInfo !== null) {
      this.userActive = this.userInfo.active;
      this.userType = this.userInfo.userType;
      this.userName = this.userInfo.userName;
      return this.userInfo;
    }
    return this.userInfo;
    // return this.apiRestService.getJasonRestApi('/getuserunfo/' + pnumber, 'Schoolboard Policy').subscribe>(
    //   data => {
    //     return data;
    //   }
    // );
  }

  getUserList_Adapter(pnumber) : Observable<UserInfo[]> {
    return this.apiRestService.getJasonRestApi(this.apiCall + pnumber, 'Schoolboard Policy').pipe(
      map((data: any[]) => data.map(
        item => this.adapter.adapt(item)
      )),
      catchError(error => {
        return throwError(error || 'something went wrong for mapping user info');
      })
    );
  }

  getCurrentUserInfo_New(apiCall) {
    return this.apiRestService.getJasonRestApi(apiCall, 'Schoolboard Policy').pipe(
      catchError(error => {
        return throwError(error || 'something went wrong for category mapping');
      })
    );
  }

  setCurrentUserInfo(pnumber) : UserInfo {
    this.getCurrentUserInfo_Adapter(pnumber).subscribe(
      data => {
        alert("Data: " + JSON.stringify(data));
        this.userInfo = data;
        if (this.userInfo.userType === 'Admin' || this.userInfo.userType === 'User') {
          localStorage.setItem('UserInfo', JSON.stringify(this.userInfo));
          //this.setUserInfoState(this.userInfo);
        }
      }
    );
    return this.userInfo;
  }

  setCurrentUserInfo_New(userInfo) {
    if (userInfo.userType === 'Admin' || userInfo.userType === 'User') {
      localStorage.setItem('UserInfo', JSON.stringify(userInfo));
      //this.setUserInfoState(this.userInfo);
    }
  }

  addUser(apiCall, content) {
    return this.apiRestService.postJasonRestApi(apiCall, 'Schoolboard Policy', content).pipe(
      catchError(error => {
        return throwError(error || 'something went wrong for user add post mapping')
      })
    );
  }

  private getCurrentUserInfo_Adapter(pnumber) {
    return this.apiRestService.getJasonRestApi('/getuserlist/' + pnumber, 'Schoolboard Policy').pipe(
      catchError(error => {
        alert("error: " + JSON.stringify(error));
        return throwError(error || 'something went wrong for mapping user info: getUserInfo')
      })
    );
  }

  private getCurrentUserInfo_Adapter_Save(pnumber) : Observable<UserInfo>{
    return this.apiRestService.getJasonRestApi('/getuserlist/' + pnumber, 'Schoolboard Policy').pipe(
      map((data: UserInfo) => this.adapter.adapt(data)
      ),
      catchError(error => {
        alert("error: " + JSON.stringify(error));
        return throwError(error || 'something went wrong for mapping user info: getUserInfo')
      }

      )
    );
  }

  // setUserInfoState(userInfo) {
  //   //this._userInfoState.next(Object.assign(userInfo));
  // }

  private getUserInfoStorage() {
    // let userInfoStorage = localStorage.getItem('UserInfo');
    this.userInfo = JSON.parse(localStorage.getItem('UserInfo'));
    if (this.userInfo === undefined || this.userInfo === null) {
      //this.userInfo = {};
      this.userInfo = null;
    }
    else {
      this.userPNumber = this.userInfo.userPNumber;
    }
    return this.userInfo;
  }

  private checkCurrentUserType(pnumber) {
    let adminUser : boolean = false;
    this.userInfo = this.getUserInfoStorage();
    if (this.userInfo !== undefined && this.userInfo !== null) {
      if (this.userInfo.userPNumber === pnumber) {
        this.userType = this.userInfo.userType;
        this.userActive = this.userInfo.active;
        // if (this.userInfo.active && this.userInfo.userType === 'Admin') {
        //   adminUser = true;
        // }
      }
    }
    return adminUser;
  }

}
